import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
    getPositionList as getPositionListApi,
    getPosition as getPositionApi,
    // getPositionQuery as getPositionQueryApi,
    addNewPosition as addNewPositionApi,
    updatePosition as updatePositionApi,
    deletePosition as deletePositionApi,
} from '../../helpers/warehouse/backend_helper';

export const getPositionList = createAsyncThunk(
    'Positions/getPositionList',
    async () => {
        try {
            const response = getPositionListApi();
            return response;
        } catch (error) {
            throw new Error(error);
        }
    }
);

// export const getPositionQuery = createAsyncThunk(
//     'Positions/getPositionQuery',
//     async params => {
//         try {
//             const response = getPositionQueryApi(params);
//             return response;
//         } catch (error) {
//             throw new Error(error);
//         }
//     }
// );

export const getPosition = createAsyncThunk(
    'Positions/getPosition',
    async Position_id => {
        try {
            const response = getPositionApi(Position_id);
            return response;
        } catch (error) {
            throw new Error(error);
        }
    }
);

export const addNewPosition = createAsyncThunk(
    'Positions/addNewPosition',
    async Position => {
        try {
            const response = await addNewPositionApi(Position);
            toast.success('Positiona agregada exitosamente.', { autoClose: 3000 });
            return response;
        } catch (error) {
            // Extract error message from backend response
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Error al agregar Positiona';
            toast.error(errorMessage, { autoClose: 5000 });
            throw new Error(error);
        }
    }
);

export const updatePosition = createAsyncThunk(
    'Positions/updatePosition',
    async Position => {
        try {
            const response = await updatePositionApi(Position);
            toast.success('Positiona actualizada exitosamente', { autoClose: 3000 });
            return response;
        } catch (error) {
            // Extract error message from backend response
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Error al actualizar Positiona';
            toast.error(errorMessage, { autoClose: 5000 });
            throw new Error(error);
        }
    }
);

export const deletePosition = createAsyncThunk(
    'Positions/deletePosition',
    async Position => {
        try {
            const response = await deletePositionApi(Position);
            toast.success('Positiona eliminada exitosamente.', { autoClose: 3000 });
            return { Position, ...response };
        } catch (error) {
            // Extract error message from backend response
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Error al eliminar Positiona';
            toast.error(errorMessage, { autoClose: 5000 });
            throw new Error(error);
        }
    }
);